import axiosInstance from "../../../../axiosInstance";
import { HRMS_UTILITY_API_URL } from "../../../Constants/baseConstant";
import { toast } from "react-toastify";

export const contactEmailHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance("/ancillary/addContactUs", {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
          Name:params?.emailid,
          Email: params?.name,
          Subject:params?.subject,
          Message:params?.message,
        }
    })
        .then((res) => {
          toast.dismiss();
          toast.success("Thanks for reaching us. Our team will get in touch shortly.")
          return { message: res?.data };
        })
        .catch((err) => {
          toast.dismiss();
          err?.response?.data?.error?.[0]?.message && toast.error(err?.response?.data?.error?.[0]?.message)
          return { message: err?.response?.data };
        });
};
